module.exports = __webpack_public_path__ + "img/car.1765f08c.png";